import * as Yup from 'yup';
import {ApplicationCategory, ApplicationStatus} from '../types';

export const RecordSchema = Yup.object()
                               .shape({
                                          // FNP-1498: THE NAME CARRIES NO
                                          // FORMAT RULE. It is a human name —
                                          // "Flexi Testing" is valid.
                                          //
                                          // ⚠️ DO NOT REINTRODUCE THE SLUG
                                          // REGEX. It existed only because the
                                          // name was once the stem of derived
                                          // resource names. An application
                                          // record is a business record, and no
                                          // infrastructure fact lives on it
                                          // (FNP-1496).
                                          //
                                          // Uniqueness still applies, and is
                                          // still the server's to enforce.
                                          name: Yup.string()
                                                   .required('Required'),

                                          description: Yup.string()
                                                          .required('Required'),

                                          // FNP-279: applicationCategory must
                                          // be set so the list table doesn't
                                          // render "Invalid Category" badges.
                                          applicationCategory: Yup.string()
                                                                  .oneOf(Object.values(ApplicationCategory))
                                                                  .required('Please select a category'),

                                          // FNP-1680: ACTIVE or INACTIVE, the
                                          // only two values console-api's enum
                                          // declares.
                                          applicationStatus: Yup.string()
                                                                .oneOf(Object.values(ApplicationStatus))
                                                                .required('Please select a status'),

                                      });
